"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserNoteEntityType = void 0;
var UserNoteEntityType;
(function (UserNoteEntityType) {
    UserNoteEntityType["ADMIN"] = "ADMIN";
    UserNoteEntityType["CONTACT"] = "CONTACT";
    UserNoteEntityType["CUSTOMER"] = "CUSTOMER";
    UserNoteEntityType["SUBSCRIPTION"] = "SUBSCRIPTION";
    UserNoteEntityType["ORDER"] = "ORDER";
    UserNoteEntityType["CHARGE"] = "CHARGE";
    UserNoteEntityType["REFUND"] = "REFUND";
    UserNoteEntityType["CART"] = "CART";
    UserNoteEntityType["DOCTOR"] = "DOCTOR";
    UserNoteEntityType["DOCTOR_AUTH"] = "DOCTOR_AUTH";
    UserNoteEntityType["DOCTOR_FAX"] = "DOCTOR_FAX";
    UserNoteEntityType["DOCTOR_CALL"] = "DOCTOR_CALL";
    UserNoteEntityType["PARTNERSHIP"] = "PARTNERSHIP";
})(UserNoteEntityType = exports.UserNoteEntityType || (exports.UserNoteEntityType = {}));
